import {
    STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getVersionsDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                versionOptions: [],
                versionOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getVersionsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                versionOptions: action.data,
                versionOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getVersionsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                versionOptions: [],
                versionOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  